<ng-container rtBlock="sc-cookies-page">
    <sc-page-header>
        <h1 slot="title" i18n="@@cookiesTitle">Cookies</h1>
    </sc-page-header>

    <div rtElem="body">
        <aside rtElem="toc" aria-label="Table of contents" i18n-aria-label="@@cookiesTocLabel">
            <h2 rtElem="toc-title" i18n="@@cookiesTocHead">Содержание</h2>
            <ol rtElem="toc-list">
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s1"
                        i18n="@@cookiesToc1"
                        [rtMod]="{ active: activeSectionId() === 's1' }"
                        (click)="onTocClick($event, 's1')">
                        Необходимые
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s2"
                        i18n="@@cookiesToc2"
                        [rtMod]="{ active: activeSectionId() === 's2' }"
                        (click)="onTocClick($event, 's2')">
                        Аналитические
                    </a>
                </li>
                <li rtElem="toc-item">
                    <a
                        rtElem="toc-link"
                        href="#s3"
                        i18n="@@cookiesToc3"
                        [rtMod]="{ active: activeSectionId() === 's3' }"
                        (click)="onTocClick($event, 's3')">
                        Управление согласием
                    </a>
                </li>
            </ol>
        </aside>

        <main rtElem="main">
            <section rtElem="section" id="s1">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">01 /</span>
                    <span i18n="@@cookiesNecessaryTitle">Необходимые</span>
                </h2>
                <p rtElem="section-p" i18n="@@cookiesIntro">
                    GoldenCalc использует cookies и аналогичные технологии локального хранения для работы конструктора, сохранения вашей
                    конфигурации между сессиями и сбора обезличенной аналитики посещений. Ниже — какие cookies мы используем и как ими
                    управлять.
                </p>
                <p rtElem="section-p" i18n="@@cookiesNecessaryText">
                    Хранят локальное состояние конструктора (последнюю конфигурацию лестницы, выбор языка, размер UI) — без них сайт не
                    сможет корректно работать. Загружаются всегда, согласие не требуется.
                </p>
            </section>

            <section rtElem="section" id="s2">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">02 /</span>
                    <span i18n="@@cookiesAnalyticsTitle">Аналитические</span>
                </h2>
                <p rtElem="section-p" i18n="@@cookiesAnalyticsText">
                    Сторонние сервисы аналитики собирают обезличенную статистику посещений (страна, браузер, устройство, действия в
                    конструкторе). Загружаются только после вашего согласия в cookie-баннере.
                </p>
            </section>

            <section rtElem="section" id="s3">
                <h2 rtElem="section-h2">
                    <span rtElem="section-num">03 /</span>
                    <span i18n="@@cookiesManageTitle">Управление согласием</span>
                </h2>
                <p rtElem="section-p" i18n="@@cookiesManageText">
                    Вы можете в любой момент изменить решение по аналитическим cookies — кнопка ниже снова откроет cookie-баннер. Также вы
                    можете очистить cookies сайта в настройках браузера.
                </p>
                <button rtElem="manage" rtButton type="button" i18n="@@cookiesManageButton" (click)="reopenConsentBanner()">
                    Управлять согласием
                </button>
            </section>
        </main>
    </div>
</ng-container>
